import { Field } from 'redux-form'

export default BaseComponent => {
  const FieldWrapperHOC = props => {
    return (
      <Field
        {...props}
        name={props.name}
        component={BaseComponent}
      />
    )
  }

  return FieldWrapperHOC
}



// WEBPACK FOOTER //
// ./components/hoc/FieldWrapperHOC/FieldWrapperHOC.jsx